import { AddToCartState, ADD_FREE_PRODUCTS_PUBLIC_DATA_KEYS } from './constants';
var AddToCartService = /** @class */ (function () {
    function AddToCartService(_siteStore, publicData) {
        if (publicData === void 0) { publicData = {}; }
        var isLegacy = publicData.APP && publicData.APP[ADD_FREE_PRODUCTS_PUBLIC_DATA_KEYS.ALLOW_FREE_PRODUCTS] === false;
        this.allowFreeProducts = !isLegacy;
    }
    AddToCartService.prototype.getButtonState = function (_a) {
        var price = _a.price, inStock = _a.inStock, _b = _a.isPreOrderState, isPreOrderState = _b === void 0 ? false : _b;
        if (isPreOrderState) {
            return AddToCartState.PRE_ORDER;
        }
        if (!inStock) {
            return AddToCartState.OUT_OF_STOCK;
        }
        if (price === 0) {
            return this.allowFreeProducts ? AddToCartState.ENABLED : AddToCartState.DISABLED;
        }
        if (price < 0) {
            return AddToCartState.DISABLED;
        }
        return AddToCartState.ENABLED;
    };
    return AddToCartService;
}());
export { AddToCartService };
//# sourceMappingURL=AddToCartService.js.map